const API_BASE = String(
  process.env.REACT_APP_API_BASE_URL ||
    "http://localhost:5000/api"
).replace(/\/+$/, "");

// ============================================================
// GET TOKEN
// ============================================================

function getToken() {
  return localStorage.getItem("token");
}

// ============================================================
// BUILD HEADERS
// ============================================================

function buildHeaders(options = {}, isFormData = false) {
  const headers = new Headers(options.headers || {});

  const token = getToken();

  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  headers.set("Accept", "application/json");

  if (!isFormData && options.body !== undefined) {
    headers.set("Content-Type", "application/json");
  }

  return headers;
}

// ============================================================
// PARSE RESPONSE
// ============================================================

async function parseResponse(response) {
  const contentType =
    response.headers.get("content-type") || "";

  if (contentType.includes("application/json")) {
    return await response.json();
  }

  const text = await response.text();

  return text || null;
}

// ============================================================
// CREATE ERROR
// ============================================================

function makeError(response, data) {
  let message =
    `Request failed with status ${response.status}`;

  if (data && typeof data === "object") {
    if (data.error) {
      message = data.error;
    } else if (data.message) {
      message = data.message;
    }
  } else if (
    typeof data === "string" &&
    data.trim()
  ) {
    message = data;
  }

  const error = new Error(message);

  error.status = response.status;
  error.data = data;
  error.response = response;

  return error;
}

// ============================================================
// HANDLE SUSPENDED ACCOUNT
// If the backend reports the account is suspended, clear the
// session and force the user back to the login page with a
// clear message — regardless of which page/API call triggered it.
// ============================================================

function handleSuspended() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  } catch (e) {}

  if (
    typeof window !== "undefined" &&
    window.location &&
    window.location.pathname !== "/login"
  ) {
    window.location.href = "/login?reason=suspended";
  }
}

// ============================================================
// NORMAL API REQUEST
// ============================================================

export async function apiRequest(
  path,
  options = {}
) {
  const isFormData =
    options.body instanceof FormData;

  const headers = buildHeaders(
    options,
    isFormData
  );

  const response = await fetch(
    `${API_BASE}${path}`,
    {
      ...options,
      headers,
    }
  );

  const data = await parseResponse(response);

  if (!response.ok) {
    if (
      response.status === 403 &&
      data &&
      typeof data === "object" &&
      data.suspended
    ) {
      handleSuspended();
    }

    throw makeError(response, data);
  }

  return data;
}

// ============================================================
// FILE / FORM UPLOAD
// ============================================================

export async function apiUpload(
  path,
  formData,
  options = {}
) {
  if (!(formData instanceof FormData)) {
    throw new Error(
      "apiUpload requires FormData."
    );
  }

  const headers = new Headers(
    options.headers || {}
  );

  const token = getToken();

  if (token) {
    headers.set(
      "Authorization",
      `Bearer ${token}`
    );
  }

  headers.set(
    "Accept",
    "application/json"
  );

  // IMPORTANT:
  // Do NOT set Content-Type manually for FormData.
  // Browser will automatically add multipart boundary.

  const response = await fetch(
    `${API_BASE}${path}`,
    {
      ...options,
      method: options.method || "POST",
      body: formData,
      headers,
    }
  );

  const data = await parseResponse(response);

  if (!response.ok) {
    if (
      response.status === 403 &&
      data &&
      typeof data === "object" &&
      data.suspended
    ) {
      handleSuspended();
    }

    throw makeError(response, data);
  }

  return data;
}

// ============================================================
// DEFAULT EXPORT
// ============================================================

export default apiRequest;